/* Ubuntu Film Co custom cart drawer. Replaces Dawn's cart-drawer.js and UpCart.
   Talks to the Shopify AJAX cart API and renders client-side. */
(function () {
  if (customElements.get('cart-drawer')) return;

  const money = (cents, currency) => {
    try {
      return 'R ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    } catch (e) { return 'R' + (cents / 100).toFixed(2); }
  };
  const esc = (s) => String(s || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  class UfcCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.threshold = parseInt(this.dataset.threshold || '0', 10);
      this.currency = this.dataset.currency || 'ZAR';
      this.itemsEl = this.querySelector('[data-items]');
      this.emptyEl = this.querySelector('[data-empty]');
      this.footEl = this.querySelector('[data-foot]');
      this.upsellsEl = this.querySelector('[data-upsells]');
      this.busy = false;
      try { this.cart = JSON.parse(this.querySelector('[data-cart-json]').textContent); } catch (e) { this.cart = null; }

      this.querySelector('#CartDrawer-Overlay').addEventListener('click', () => this.close());
      this.querySelector('[data-cart-close]').addEventListener('click', () => this.close());
      this.addEventListener('keyup', (e) => e.code === 'Escape' && this.close());
      this.itemsEl.addEventListener('click', (e) => this.onItemClick(e));
      this.querySelectorAll('[data-upsell]').forEach((u) => this.bindUpsell(u));
      this.protectEl = this.querySelector('[data-protect]');
      if (this.protectEl) {
        this.protectEl.querySelector('[data-protect-check]').addEventListener('change', (e) => this.toggleProtect(e.target.checked));
      }
      this.setHeaderCartIcon();
      if (this.cart) this.render();
      else this.refresh();

      document.addEventListener('ufc:cart:open', () => this.open());
      document.addEventListener('ufc:cart:refresh', () => this.refresh(true));
    }

    setHeaderCartIcon() {
      const link = document.querySelector('#cart-icon-bubble');
      if (!link) return;
      link.setAttribute('role', 'button');
      link.setAttribute('aria-haspopup', 'dialog');
      link.addEventListener('click', (e) => { e.preventDefault(); this.open(link); });
    }

    /* Dawn product-form.js contract */
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsedState) {
      if (parsedState && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble) {
          const html = new DOMParser().parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
          const src = html.querySelector('.shopify-section');
          if (src) bubble.innerHTML = src.innerHTML;
        }
      }
      this.refresh(false).then(() => this.open());
    }

    open(triggeredBy) {
      if (triggeredBy) this.activeElement = triggeredBy;
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
      setTimeout(() => this.querySelector('#CartDrawer').focus(), 50);
    }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
    }

    async refresh(updateBubble = true) {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      this.cart = await res.json();
      this.render();
      if (updateBubble) this.updateBubble();
      return this.cart;
    }

    updateBubble() {
      fetch('/?section_id=cart-icon-bubble').then((r) => r.text()).then((html) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const src = doc.querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      }).catch(() => {});
    }

    render() {
      const c = this.cart;
      if (!c) return;
      const protectId = this.protectEl ? this.protectEl.dataset.productId : null;
      const visibleItems = c.items.filter((i) => String(i.product_id) !== protectId);
      const empty = visibleItems.length === 0;
      this.classList.toggle('is-empty', empty);
      this.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = visibleItems.reduce((n, i) => n + i.quantity, 0)));
      this.querySelectorAll('[data-subtotal]').forEach((el) => (el.textContent = money(c.total_price, this.currency)));

      /* free shipping bar */
      const ship = this.querySelector('[data-ship]');
      if (ship && this.threshold > 0) {
        const remaining = Math.max(0, this.threshold - c.total_price);
        const pct = Math.min(100, Math.round((c.total_price / this.threshold) * 100));
        this.querySelector('[data-ship-bar]').style.width = pct + '%';
        ship.classList.toggle('is-unlocked', remaining === 0);
        this.querySelector('[data-ship-text]').innerHTML = remaining === 0
          ? '<b>You have unlocked free shipping!</b>'
          : 'You are <b>' + money(remaining, this.currency) + '</b> away from <b>free shipping</b>';
      }

      /* items */
      this.itemsEl.innerHTML = visibleItems.map((it) => `
        <li class="ufc-cart__item" data-key="${esc(it.key)}">
          <a class="ufc-cart__item-img" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160')}" alt="${esc(it.product_title)}" width="80" height="80" loading="lazy">` : ''}</a>
          <div class="ufc-cart__item-info">
            <a class="ufc-cart__item-title" href="${esc(it.url)}">${esc(it.product_title)}</a>
            ${it.variant_title && it.variant_title !== 'Default Title' ? `<span class="ufc-cart__item-var">${esc(it.variant_title)}</span>` : ''}
            ${(it.properties && Object.keys(it.properties).length) ? `<span class="ufc-cart__item-var">${Object.entries(it.properties).filter(([k]) => !k.startsWith('_')).map(([k, v]) => esc(k) + ': ' + esc(v)).join(' · ')}</span>` : ''}
            <div class="ufc-cart__item-row">
              <div class="ufc-cart__qty" aria-label="Quantity">
                <button type="button" data-qty="-1" aria-label="Decrease quantity">−</button>
                <span>${it.quantity}</span>
                <button type="button" data-qty="1" aria-label="Increase quantity">+</button>
              </div>
              <div class="ufc-cart__item-price">
                ${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price, this.currency)}</s>` : ''}
                <b>${money(it.final_line_price, this.currency)}</b>
              </div>
            </div>
            <button type="button" class="ufc-cart__remove" data-remove>Remove</button>
          </div>
        </li>`).join('');

      /* discounts */
      const d = this.querySelector('[data-discounts]');
      if (d) d.innerHTML = (c.cart_level_discount_applications || []).map((a) => `<span>${esc(a.title)} <b>−${money(a.total_allocated_amount, this.currency)}</b></span>`).join('');

      /* hide upsells that are already in the cart */
      const inCart = new Set(c.items.map((i) => String(i.product_id)));
      const handles = new Set(c.items.map((i) => i.handle));
      let shown = 0;
      this.querySelectorAll('[data-upsell]').forEach((u) => {
        const blocked = (u.dataset.hideHandles || '').split(',').filter(Boolean).some((h) => handles.has(h));
        const hide = inCart.has(u.dataset.productId) || blocked || shown >= 2;
        u.classList.toggle('is-hidden', hide);
        if (!hide) shown++;
      });
      if (this.upsellsEl) {
        const visible = this.upsellsEl.querySelectorAll('[data-upsell]:not(.is-hidden)').length;
        this.upsellsEl.classList.toggle('is-hidden', visible === 0 || empty);
      }
      this.syncProtect(visibleItems);
    }

    /* Shipping protection: auto-added with the first item, removed when the bag empties, remembers opt-out */
    syncProtect(visibleItems) {
      const p = this.protectEl;
      if (!p || !this.cart) return;
      const pid = p.dataset.productId;
      const prot = this.cart.items.find((i) => String(i.product_id) === pid);
      const chk = p.querySelector('[data-protect-check]');
      let optOut = false;
      try { optOut = localStorage.getItem('ufc_protect_off') === '1'; } catch (e) {}
      if (prot && visibleItems.length === 0) { chk.checked = false; if (!this.busy) this.change(prot.key, 0); return; }
      if (!prot && visibleItems.length > 0 && p.dataset.default === 'true' && !optOut && !this.protectTried) {
        this.protectTried = true;
        if (!this.busy) this.add(p.dataset.variantId, null, true);
        return;
      }
      chk.checked = !!prot;
    }

    async toggleProtect(on) {
      const p = this.protectEl;
      const pid = p.dataset.productId;
      const prot = this.cart && this.cart.items.find((i) => String(i.product_id) === pid);
      try { on ? localStorage.removeItem('ufc_protect_off') : localStorage.setItem('ufc_protect_off', '1'); } catch (e) {}
      if (on && !prot) { this.protectTried = true; await this.add(p.dataset.variantId, null, true); }
      else if (!on && prot) { await this.change(prot.key, 0); }
    }

    onItemClick(e) {
      const li = e.target.closest('.ufc-cart__item');
      if (!li) return;
      const key = li.dataset.key;
      const item = this.cart.items.find((i) => i.key === key);
      if (!item) return;
      if (e.target.closest('[data-remove]')) return this.change(key, 0);
      const q = e.target.closest('[data-qty]');
      if (q) return this.change(key, item.quantity + parseInt(q.dataset.qty, 10));
    }

    async change(key, quantity) {
      if (this.busy) return;
      this.setBusy(true);
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        this.cart = await res.json();
        this.render();
        this.updateBubble();
        document.dispatchEvent(new CustomEvent('ufc:cart:updated', { detail: this.cart }));
      } finally { this.setBusy(false); }
    }

    bindUpsell(u) {
      const btn = u.querySelector('[data-upsell-add]');
      const sel = u.querySelector('[data-upsell-select]');
      const price = u.querySelector('[data-upsell-price]');
      if (sel) sel.addEventListener('change', () => {
        btn.dataset.variantId = sel.value;
        const opt = sel.options[sel.selectedIndex];
        if (price && opt.dataset.price) price.textContent = money(parseInt(opt.dataset.price, 10), this.currency);
      });
      btn.addEventListener('click', () => this.add(btn.dataset.variantId, btn));
    }

    async add(variantId, btn, silent) {
      if (this.busy) return;
      this.setBusy(true);
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        });
        if (!res.ok) throw new Error('add failed');
        await this.refresh();
        if (!silent) this.open();
        if (btn) { btn.textContent = 'Added'; setTimeout(() => { btn.textContent = 'Add'; btn.disabled = false; }, 1500); }
      } catch (e) {
        if (btn) { btn.textContent = 'Try again'; btn.disabled = false; }
      } finally { this.setBusy(false); }
    }

    setBusy(b) { this.busy = b; this.classList.toggle('is-busy', b); }
  }

  customElements.define('cart-drawer', UfcCartDrawer);

  /* Global helper so any button can add + open: data-ufc-add="VARIANT_ID" */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ufc-add]');
    if (!b) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.add(b.dataset.ufcAdd, b);
  });
})();
